import styled from 'styled-components';
import Slider from 'react-slick';

export const InPageFeaturesV6Container = styled.div`
  padding: 0 0 125px;
  margin: 0 0 0 -20px;

  .in-page-commercial--title {
    margin: 0 auto;
    text-align: center;
    margin-top: 75px;
  }

  .in-page-features-disclaimer {
    margin-top: 35px;

    p {
      color: var(--grey-6);
      font-size: 16px;
    }
  }

  .in-page-features-stat {
    display: flex;
    align-items: center;
    margin-top: 50px;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-size: 35px;
      margin: 0 15px 0 0;
      color: var(--titan-blue-3);
    }
    p {
      color: var(--darkest);
      margin: 0;
    }
  }

  .in-page-commercial--wrapper {
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    padding-left: calc((100vw - min(81.6vw, 1306px) - 110px) / 2);

    .in-page-commercial--featured-content {
      width: 100%;

      .in-page-commercial--featured-content-wrapper {
        width: 100%;
        position: relative;

        .in-page-commercial--featured-item {
          width: 81.6vw !important;
          max-width: 1306px;
          margin: 0 0 0 55px;

          .in-page-commercial--featured-item-wrapper {
            width: 100%;
            height: 550px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 20px 80px;
            padding: 75px 0;

            .in-page-commercial--featured-item-image {
              flex: 1;
              width: 100%;
              height: 100%;
              filter: drop-shadow(0px 15px 40px rgba(11, 26, 33, 0.1));
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .in-page-commercial--featured-item-copy {
              flex: 1;

              .tag {
                box-shadow: none;
                border-radius: 4px !important;
                border-color: #e5ebee;
                padding: 5px 10px;
                font-size: 16px;
                margin: 0 10px 10px 0;

                &:hover {
                  background: rgba(175, 203, 249, 0.2);
                }
              }

              h6.in-page-features-commercial--featured-content-heading {
                font-family: var(--font-family-body) !important;
                font-size: var(--font-size-h6) !important;
                font-weight: var(--font-weight-400) !important;
                line-height: var(--line-height-150) !important;
                color: var(--grey-6);
              }

              .in-page-features-commercial--featured-content-description {
                font-family: var(--font-family-heading);
                font-weight: 500;
                padding-right: 63px;

                @media (max-width: 991px) {
                  padding: 0;
                }
              }
            }
          }
        }

        .in-page-commercial--featured-slider-arrow {
          position: absolute;
          width: 40px;
          height: 40px;
          background: #ffffff;
          border: 1px solid #dfe0e1;
          border-radius: 50%;
          bottom: -45px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          span {
            font-family: var(--font-family-body);
            font-size: var(--font-size-p);
            font-weight: var(--font-weight-800);
            line-height: var(--line-height-120);
            position: absolute;
            white-space: nowrap;
            padding: 10px 20px;
          }

          &.arrow-left {
            left: 60px;

            span {
              left: 40px;
            }
          }

          &.arrow-right {
            right: calc((100vw - min(81.6vw, 1306px)) / 2 - 10px);

            span {
              right: 40px;
            }
          }
        }
      }
    }
  }

  @media (max-width: 991px) {
    .in-page-commercial--wrapper {
      padding: 0;

      .in-page-commercial--featured-content {
        .in-page-commercial--featured-content-wrapper {
          .in-page-commercial--featured-item {
            width: calc(100vw - 20px) !important;
            max-width: 100%;
            margin: 0;
            padding: 0 28px;

            .in-page-commercial--featured-item-wrapper {
              height: 400px;
              gap: 40px;
            }
          }

          .in-page-commercial--featured-slider-arrow {
            bottom: -28px;

            &.arrow-left {
              left: 28px;
            }

            &.arrow-right {
              right: 28px;
            }
          }
        }
      }
    }
  }

  @media (max-width: 767px) {
    padding: 25px 16px 50px 16px;
    margin: 0;

    .in-page-commercial--title {
      margin-top: 50px;
    }

    .in-page-commercial--wrapper {
      .in-page-commercial--featured-content {
        .in-page-commercial--featured-content-wrapper {
          display: flex;
          flex-direction: column;
          gap: 50px 0;
          margin-top: 50px;
          width: 100% !important;

          .in-page-commercial--featured-item {
            width: 100% !important;
            max-width: 100%;
            margin: 0;
            padding: 0 28px;

            .in-page-commercial--featured-item-wrapper {
              height: 100%;
              flex-direction: column;
              max-width: 500px;
              margin: 0 auto;
              padding: 0;

              .in-page-commercial--featured-item-image {
                filter: none;
              }

              .in-page-commercial--featured-item-copy
                .in-page-features-commercial--featured-content-heading {
                font-size: var(--font-size-mobile-h3);
              }
            }
          }
        }
      }
    }
  }
`;

export const FeaturedContentSlider = styled(Slider)`
  .slick-dots {
    bottom: -36px;
    left: 55px;
    width: min(81.6vw, 1306px);

    button {
      width: 20px;
      height: 20px;
      &:before {
        font-size: 14px;
        color: var(--grey-3);
        opacity: 1;
      }
    }

    .slick-active {
      button {
        &:before {
          color: var(--titan-blue-3);
          opacity: 1;
        }
      }
    }
  }

  @media (max-width: 991px) {
    .slick-list {
      overflow: visible;
    }

    .slick-dots {
      width: 100%;
      left: 0;
      bottom: -20px;
    }
  }
`;

export const FeaturedContentInnerContainer = styled.div`
  width: 100%;
  height: auto;
  flex: 1;
  margin: 0 auto;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
`;
